// extracted by mini-css-extract-plugin
export default {"root":"faq_root__ojbdx"};